import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import sqliteImmediateStorage from "./sqliteImmediateStorage";

const useAdvanceOrderStore = create(
  persist(
    (set) => ({
      isAdvanceOrderEnabled: false,

      setIsAdvanceOrderEnabled: (value) => set({ isAdvanceOrderEnabled: value }),

      resetAdvanceOrder: () => set({ isAdvanceOrderEnabled: false }),
    }),
    {
      name: "advance-order-store",
      storage: createJSONStorage(() => (window.electronAPI?.db ? sqliteImmediateStorage : localStorage)),
      skipHydration: true,
    }
  )
);

export default useAdvanceOrderStore;
